<template>
  <div class="content">
    <h1>Account Deletion & Data Erasure Request</h1>
    <p><strong>Application:</strong> Liveo</p>
    <p><strong>Developer/Company:</strong> Hong Kong Tuiyan Intelligent Technology Limited</p>

  <div class="section">
    <h2>Important Notes</h2>
    <p>By submitting an account deletion request, you acknowledge that:</p>
    <ul>
      <li>Your Liveo account will be <span class="highlight">permanently deleted and cannot be restored</span>.</li>
      <li>All your personal data associated with Liveo will be <span class="highlight">permanently erased</span> from our active databases within 7 business days.</li>
      <li>Anonymized or aggregated data (e.g., usage statistics that cannot identify you) may be retained for legal or analytical purposes.</li>
    </ul>
  </div>

  <div class="section">
    <h2>How to Request Account Deletion</h2>
    <p>To delete your Liveo account, please follow the methods below:</p>
    <h3>Method 1 </h3>
      <ol>
        <li>Send an email to: <a href="mailto:dbandrewxu@gmail.com">dbandrewxu@gmail.com</a></li>
        <li>Subject: <strong>Liveo Account Deletion Request</strong></li>
        <li>Body: Include Your login account (e.g., Google Account/Phone Number) and a brief request to delete your account.</li>
        <li>We will process your request within <strong>7 business days</strong> and notify you via email upon completion.</li>
      </ol>
  </div>

  <div class="section">
    <h2>Contact Us</h2>
      <p>If you have any questions about account deletion or data privacy, contact our support team:</p>
      <p>Email: <a href="mailto:dbandrewxu@gmail.com">dbandrewxu@gmail.com</a></p>
      <p>Privacy Policy: <a href="https://www.evolvetechly.com/privacy-policy?lang=en">https://www.evolvetechly.com/privacy-policy</a></p>
  </div>
  </div>
</template>
<script>
  export default {
    name: 'GoogleDelete',
  }
</script>
<style scoped>
  body { font-family: Arial, sans-serif; max-width: 800px; margin: 2rem auto; padding: 0 1rem; 
  line-height: 1.6; }
  .content{
    width: 50%;
    margin: 0 auto;
  }
  h1 { color: #202124; font-size: 1.8rem; }
  h2 { color: #5f6368; font-size: 1.2rem; margin-top: 1.5rem; }
  .section { margin: 1.5rem 0; }
  .highlight { font-weight: 600; color: #d93025; }
</style>